// extracted by mini-css-extract-plugin
export default {"ProfileLayout":"ProfileLayout_ProfileLayout__hGREh"};